import type { ExportTemplateDefinition } from "./types";

export const DEFAULT_TEMPLATE_ID = "kpi-trends-callouts";

export const exportTemplates: Record<string, ExportTemplateDefinition> = {
  [DEFAULT_TEMPLATE_ID]: {
    id: DEFAULT_TEMPLATE_ID,
    name: "KPI + Trends + Callouts",
    description:
      "Hero header with KPI ribbon, performance trends, brand share, and key callouts for quick deck drops.",
    modules: [
      {
        id: "kpi-grid",
        type: "kpi-grid",
        title: "Performance KPIs",
        span: 12,
      },
      {
        id: "trend-line",
        type: "trend-line",
        title: "Daily Performance Trend",
        span: 7,
        props: { metric: "total_sales" },
      },
      {
        id: "brand-share",
        type: "brand-share",
        title: "Top Brand Contribution",
        span: 5,
        props: { metric: "total_sales" },
      },
      {
        id: "callouts",
        type: "callouts",
        title: "Key Callouts",
        span: 12,
      },
    ],
    background: {
      gradientFrom: "#fff5ec",
      gradientTo: "#f2f0ff",
    },
  },

  "executive-summary": {
    id: "executive-summary",
    name: "Executive Summary",
    description:
      "KPI-only boardroom view — headline numbers in large format with key callouts.",
    modules: [
      {
        id: "kpi-hero",
        type: "kpi-hero",
        title: "Performance Summary",
        span: 12,
      },
      {
        id: "callouts",
        type: "callouts",
        title: "Key Takeaways",
        span: 12,
      },
    ],
    background: {
      gradientFrom: "#f8fafc",
      gradientTo: "#e2e8f0",
    },
  },

  "full-detail": {
    id: "full-detail",
    name: "Full Performance Detail",
    description:
      "All metrics and breakdowns — KPIs, daily trends, brand share, and campaign-level table.",
    modules: [
      {
        id: "kpi-grid",
        type: "kpi-grid",
        title: "Performance KPIs",
        span: 12,
      },
      {
        id: "trend-line",
        type: "trend-line",
        title: "Daily Performance Trend",
        span: 7,
        props: { metric: "total_sales" },
      },
      {
        id: "brand-share",
        type: "brand-share",
        title: "Brand Contribution",
        span: 5,
        props: { metric: "total_sales" },
      },
      {
        id: "campaign-table",
        type: "campaign-table",
        title: "Campaign Breakdown",
        span: 12,
        props: { limit: 8 },
      },
    ],
    background: {
      gradientFrom: "#f0f9ff",
      gradientTo: "#ede9fe",
    },
  },

  "search-term-focus": {
    id: "search-term-focus",
    name: "Search Term Focus",
    description:
      "Optimization-focused view — compact KPIs with prominent top and bottom campaign performers.",
    modules: [
      {
        id: "kpi-grid",
        type: "kpi-grid",
        title: "Performance KPIs",
        span: 12,
      },
      {
        id: "campaign-table",
        type: "campaign-table",
        title: "Top & Bottom Performers",
        span: 12,
        props: { limit: 12 },
      },
      {
        id: "callouts",
        type: "callouts",
        title: "Optimization Notes",
        span: 12,
      },
    ],
    background: {
      gradientFrom: "#fefce8",
      gradientTo: "#fef3c7",
    },
  },

  "brand-comparison": {
    id: "brand-comparison",
    name: "Brand Comparison",
    description:
      "Side-by-side brand performance cards with KPIs — portfolio view for multi-brand campaigns.",
    modules: [
      {
        id: "kpi-grid",
        type: "kpi-grid",
        title: "Portfolio KPIs",
        span: 12,
      },
      {
        id: "brand-comparison",
        type: "brand-comparison",
        title: "Brand-by-Brand Performance",
        span: 12,
        props: { limit: 4 },
      },
      {
        id: "callouts",
        type: "callouts",
        title: "Brand Insights",
        span: 12,
      },
    ],
    background: {
      gradientFrom: "#fdf2f8",
      gradientTo: "#fce7f3",
    },
  },
};

export function getExportTemplate(
  templateId?: string,
): ExportTemplateDefinition {
  if (templateId && exportTemplates[templateId]) {
    return exportTemplates[templateId];
  }
  return exportTemplates[DEFAULT_TEMPLATE_ID];
}
